import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';

const SplashPage = lazy(() => import('../pages/splash/page'));
const OnboardingPage = lazy(() => import('../pages/onboarding/page'));
const LanguageSelectPage = lazy(() => import('../pages/language-select/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const OTPVerifyPage = lazy(() => import('../pages/otp-verify/page'));
const CustomerHomePage = lazy(() => import('../pages/customer-home/page'));
const OrderDetailsPage = lazy(() => import('../pages/order-details/page'));
const InstantQuotePage = lazy(() => import('../pages/instant-quote/page'));
const FindingDriverPage = lazy(() => import('../pages/finding-driver/page'));
const DriverAcceptedPage = lazy(() => import('../pages/driver-accepted/page'));
const LiveTrackingPage = lazy(() => import('../pages/live-tracking/page'));
const ChatPage = lazy(() => import('../pages/chat/page'));
const TripCompletePage = lazy(() => import('../pages/trip-complete/page'));
const OrdersPage = lazy(() => import('../pages/orders/page'));
const ProfilePage = lazy(() => import('../pages/profile/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <SplashPage />
  },
  {
    path: '/onboarding',
    element: <OnboardingPage />
  },
  {
    path: '/language-select',
    element: <LanguageSelectPage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/otp-verify',
    element: <OTPVerifyPage />
  },
  {
    path: '/customer-home',
    element: <CustomerHomePage />
  },
  {
    path: '/order-details',
    element: <OrderDetailsPage />
  },
  {
    path: '/instant-quote',
    element: <InstantQuotePage />
  },
  {
    path: '/finding-driver',
    element: <FindingDriverPage />
  },
  {
    path: '/driver-accepted',
    element: <DriverAcceptedPage />
  },
  {
    path: '/live-tracking',
    element: <LiveTrackingPage />
  },
  {
    path: '/chat',
    element: <ChatPage />
  },
  {
    path: '/trip-complete',
    element: <TripCompletePage />
  },
  {
    path: '/orders',
    element: <OrdersPage />
  },
  {
    path: '/profile',
    element: <ProfilePage />
  },
  {
    path: '/404',
    element: <NotFoundPage />
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />
  }
];

export default routes;
